import { useState } from "react";
import { Dialog } from "@mui/material";
import { LoginPageTopBar } from "./TopBar/TopBar";
import NewLoginPage from "../pages/auth/LoginPage";
import TermsAndPolicy from "../shared/TermsAndPolicy";

export default function LoginLayout() {
  const [selectedTab, setSelectedTab] = useState<string>("login");
  const [dialogState, setDialogState] = useState<{
    open: boolean;
    header: string;
  }>({ open: false, header: "" });

  return (
    <>
      <LoginPageTopBar
        selectedTab={selectedTab}
        setSelectedTab={(value: string) => setSelectedTab(value)}
      />
    </>
  );
}
